var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"fill":"#FFF","d":"M7.5 13.475L4.025 10 2.842 11.175 7.5 15.833 17.5 5.833 16.325 4.658z","key":0}),React.createElement("path",{"fillRule":"nonzero","d":"M0 0H20V20H0z","key":1})]));
}

Check.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = Check;

Check.default = Check;
